// Core
import React from 'react';

// Layout
import { ParagraphSize, ParagraphWeight } from '../Paragraph';

export enum OptionsDropdownColor {
  danger = 'danger',
  normal = 'normal',
}

export enum OptionsDropdownPlacement {
  bottom = 'bottom',
  bottomLeft = 'bottomLeft',
  bottomRight = 'bottomRight',
  top = 'top',
  topLeft = 'topLeft',
  topRight = 'topRight',
}

export interface Options {
  color: OptionsDropdownColor;
  disabled: boolean;
  disabledHover?: boolean;
  icon?: React.ReactNode;
  onClick: React.MouseEventHandler<HTMLElement>;
  text: string;
}

export interface OptionsDropdownProps {
  children?: React.ReactNode;
  className?: string;
  options: Options[];
  placement?: OptionsDropdownPlacement;
  secondaryOptions?: Options[];
  testId?: string;
}

export interface OptionsDropdownItems {
  key: string;
  label: React.ReactNode;
}

export interface TextWithTooltipType {
  text: string;
  weight?: ParagraphWeight;
  size?: ParagraphSize;
}

export interface MenuItemType {
  item: Options;
  onClose: () => void;
  weight?: ParagraphWeight;
  size?: ParagraphSize;
}
